import ErrorScreen from '../../logic/error-screen/ErrorScreen';
import { SET_PLAYER_ERROR, SET_PLAYOUT_ERROR } from '../../constants/mutations';

const getInitialState = () => ({
	playerError:  null,
	playoutError: null,
});

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		[SET_PLAYER_ERROR]: (state, value) => {
			state.playerError = value;
		},
		[SET_PLAYOUT_ERROR]: (state, value) => {
			state.playoutError = value;
		},
	},
	actions: {
		setPlayerError: ({ commit }, value) => {
			commit(SET_PLAYER_ERROR, value);
		},
		setPlayoutError: ({ commit }, value) => {
			commit(SET_PLAYOUT_ERROR, value);
		},
	},
	getters: {
		errorScreen: (state, _getters, _rootState, rootGetters) => {
			const event = rootGetters['event/event'];
			const unixTime = rootGetters['event/unixTime'];
			const isTaggingTool = rootGetters['app/isTaggingToolMode'];
			const isManager = window.managerDomain && document.location.host === window.managerDomain;
			const context = isTaggingTool ? 'tagging-tool' : (isManager ? 'manager' : null);
			return ErrorScreen.fromContext({
				event,
				playerError:  state.playerError,
				playoutError: state.playoutError,
				currentTime:  unixTime,
				context,
			});
		},
		hasErrorScreen:  (_state, getters) => Boolean(getters.errorScreen),
		hasPlayoutError: (state) => Boolean(state.playoutError),
		playerError:     (state) => state.playerError,
	},
};
